import styled, { css } from 'styled-components';
import { Button } from 'components/Button';
import type { ContentCardProps } from '../types';

const ActionsAndLinkContainer = styled.div<{ $justifyLeft: boolean }>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${({ theme }) => theme.Spacing8};
    margin-top: auto;
    padding-top:  ${({ theme }) => theme.Spacing16};
    grid-template-columns: repeat(auto-fit, minmax(40%, 1fr));

    ${({ $justifyLeft }) =>
        $justifyLeft &&
        css`
            justify-items: left;
        `}
`;

const buttonStyles = css`
    flex: ${({ theme }) => `1 0 calc(50% - ${theme.Spacing4})`};
    max-width: 100%;
    white-space: nowrap;
`;

const StyledButton = styled(Button)`
    ${buttonStyles}
    z-index: 2; // above content card link

`;

const Link = styled(Button)<{ $shotFirstInActions: boolean }>`
    ${buttonStyles}

    ${({ $shotFirstInActions }) =>
        $shotFirstInActions &&
        css`
            order: -1;
        `}
`;

function ActionsAndLink({ link, actions }: Pick<ContentCardProps, 'link' | 'actions'>) {
    if (!actions?.length) return null;

    return (
        <ActionsAndLinkContainer $justifyLeft={!actions?.length}>
            {actions?.map((action, index) => (
                <StyledButton key={index} onClick={action.onClick} variant={action.variant}>
                    {action.label}
                </StyledButton>
            ))}
            {actions && link?.label && (
                <Link
                    forwardedAs="span"
                    variant={link.variant || 'tertiary'}
                    $shotFirstInActions={!!link.showFirstInActions}
                >
                    {link.label}
                </Link>
            )}
        </ActionsAndLinkContainer>
    );
}

export default ActionsAndLink;
